import React, { useState, useEffect, useRef } from "react";
import "./quickview.css";
import up from '../../assets/up.svg';
import down from '../../assets/down.svg';
import starIcon from '../../assets/star.png';
import ReactStars from "react-rating-stars-component";
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import brandLogo from '../../assets/brand.png';
import cartIcon from '../../assets/addcart.png';
import { FaFacebookF, FaTwitter, FaPinterestP, FaInstagram } from "react-icons/fa";
// import { addToCart as addToCartRedux } from '../../store/cartSlice';
import DOMPurify from 'dompurify';
import {addToCart,removeFromCart, setCart,  setTotalItems,setTotalPrice,setCartId,} from "../../store/cartSlice";
import { addToWishlist, removeFromWishlist, incrementWishlistCount, decrementWishlistCount } from '../../store/wishlistSlice';
import { useDispatch, useSelector } from 'react-redux';
import { postWithTokenAPI } from '../../util/Api';
// import { useLocation } from 'react-router-dom';
// import { productParticular } from '../../util/Api';
import { toast,ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
// import { getWithoutTokenAPI } from '../../util/Api';

const ProductCardpop = ({ isOpen, onClose, selectedProductId, productDetails = {}, product }) => {
  // const [productInfo, setProductInfo] = useState({});
  const [quantity, setQuantity] = useState(1);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const thumbnailRef = useRef(null);
  const [isLoginPopupOpen, setLoginPopupOpen] = useState(false);
  const dispatch = useDispatch();
  const [addingToCart, setAddingToCart] = useState(false);
  const [cartSuccessMessage, setCartSuccessMessage] = useState('');
  const accessToken = useSelector((state) => state.auth?.auth?.access_token);
  const isLoggedIn = useSelector((state) => state.auth?.isLoggedIn);
  const [isInWishlist, setIsInWishlist] = useState(productDetails?.wish_status || false);

  // Update wishlist status whenever productDetails changes
  useEffect(() => {
    if (productDetails) {
      setIsInWishlist(productDetails.wish_status || false);
    }
  }, [productDetails]);

  if (!isOpen || !productDetails || Object.keys(productDetails).length === 0) {
    // console.log("Popup is not open or product details are empty.");
    return null;
  }


  const decreaseQuantity = () => {
    if (quantity > 1) setQuantity(quantity - 1);
  };

  const increaseQuantity = () => {
    setQuantity(quantity + 1);
  };

  const scrollUp = () => {
    thumbnailRef.current?.scrollBy({ top: -100, behavior: 'smooth' });
  };

  const scrollDown = () => {
    thumbnailRef.current?.scrollBy({ top: 100, behavior: 'smooth' });
  };

  if (!isOpen || !productDetails || Object.keys(productDetails).length === 0) return null;

  const handleWishlistClick = async (e) => {
    e.stopPropagation();
    
    if (!isLoggedIn || !accessToken) {
      navigate('/login');
      return;
    }

    try {
      const payload = {
        product_id: productDetails._id,
        category_id: productDetails.category_id?._id || productDetails.category_id,
      };

      const response = await postWithTokenAPI(accessToken, "/wishlist/add", payload);

      if (response?.statusCode === 200) {
        // Update both local state and productDetails
        setIsInWishlist(true);
        if (productDetails) {
          productDetails.wish_status = true;
        }
        dispatch(addToWishlist(productDetails));
        toast.success('Item added to wishlist successfully!');
      } else if (response?.statusCode === 406) {
        // Update both local state and productDetails
        setIsInWishlist(false);
        if (productDetails) {
          productDetails.wish_status = false;
        }
        dispatch(removeFromWishlist(productDetails._id));
        toast.success('Item removed from wishlist');
      } else {
        console.warn("Failed to update wishlist:", response);
        toast.error('Failed to update wishlist');
      }
    } catch (error) {
      console.error("Error updating wishlist:", error);
      toast.error('Error updating wishlist');
    }
  };

  // const handleAddToCart = async (cartItem) => {
  //   if (!accessToken) {
  //     //  setLoginPopupOpen(true);
  //     navigate('/login');
  //     return;
  //   }

  //   if (!cartItem || !cartItem._id) {
  //     console.warn("Invalid product data:", cartItem);
  //     setError("Invalid product. Cannot add to cart.");
  //     return;
  //   }

  //   if (addingToCart) return;
  //   setAddingToCart(true);


  //   try {
  //     const payload = {
  //       cart: [
  //         {
  //           product_id: cartItem._id,
  //           quantity: cartItem.quantity && cartItem.quantity > 0 ? cartItem.quantity : 1,
  //         },
  //       ],
  //     };

  //     const response = await postWithTokenAPI(accessToken, '/cart/add', payload);

  //     if (response?.statusCode === 200 && response.data?.cart) {
  //       const addedItem = response.data.cart;

  //       // You may extract `cart_id` from response if needed
  //       // const cart_id = response.data.cart_id || response.data._id || null;
  //       // console.log("✅ Item added to cart. Cart ID:", cart_id);

  //       // Update Redux cart
  //       dispatch(addToCartRedux({
  //         id: addedItem.product_id,
  //         price: addedItem.price, // Make sure price is returned from backend
  //         quantity: addedItem.quantity,
  //         name: addedItem.name,   // Optional fields
  //         image: addedItem.image, // Optional fields
  //       }));

  //       toast.success('Item added to cart successfully!');
  //       setTimeout(() => setCartSuccessMessage(''), 3000);
  //     } else {
  //       console.warn("⚠️ Failed to add to cart. Status:", response.statusCode);
  //       setError("Failed to add item to cart.");
  //     }
  //   } catch (error) {
  //     console.error("❌ Error adding item to cart:", error);
  //     setError("Something went wrong while adding to cart.");
  //   } finally {
  //     setAddingToCart(false);
  //   }
  // };


  const handleAddToCart = async (cartItem) => {
  if (!accessToken) {
    navigate('/login');
    return;
  }
  if (!cartItem?._id) return;

  if (addingToCart) return;
  setAddingToCart(true);
  setError(null);

  try {
    const payload = {
      cart: [
        {
          product_id: cartItem._id,
          quantity: cartItem.quantity > 0 ? cartItem.quantity : 1,
        },
      ],
    };

    const response = await postWithTokenAPI(accessToken, "/cart/add", payload);

    // 🧹 Case: Cart emptied
    if (
      response?.statusCode === 200 &&
      response?.message === "Product removed and cart deleted as it became empty"
    ) {
      dispatch(setCart([]));
      dispatch(setTotalItems(0));
      dispatch(setTotalPrice(0));
      dispatch(setCartId(null));
      toast.info("Item removed and cart is now empty.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: `removed-${cartItem._id}`,
        theme: "light",
      });
    }

    // ✅ Case: Product added successfully
    else if (response?.statusCode === 200 && response.data?.cart) {
      const addedItem = response.data.cart;

      dispatch(
        addToCart({
          id: addedItem.product_id,
          price: addedItem.price,
          quantity: addedItem.quantity,
          name: addedItem.name,
          image: addedItem.image,
        })
      );

      toast.success("Item added to cart successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: `cart-${cartItem._id}`,
        theme: "light",
      });
    }

    // ❌ Failure case
    else {
      toast.error("Failed to add item to cart.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: `error-${cartItem._id}`,
        theme: "light",
      });
    }
  } catch (error) {
    console.error("Add to cart error:", error);
    toast.error("Something went wrong. Please try again.", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      toastId: `error-${cartItem._id}`,
      theme: "light",
    });
  } finally {
    setAddingToCart(false);
  }
};


const cleanHTML = DOMPurify.sanitize(productDetails.short_description, {
  ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'a', 'b', 'i'],
  ALLOWED_ATTR: ['href', 'target', 'rel']
});
  const starRatingConfig = {
    size: 20,
    value: productDetails.average_rating || 0,
    edit: false,
    activeColor: "#ffd700",
    color: "#d4d4d4",
    isHalf: true,
    count: 5,
    a11y: true,
    onChange: () => {},
    classNames: {
      container: "star-rating-container",
      star: "star-rating-star"
    }
  };

  return (
    <>
    <ToastContainer/>
    <div className="pcp-product-popup-overlay">
      <div className="pcp-product-popup-content">
        <button className="pcp-popup-close-btn" onClick={onClose}>×</button>

        <div className="pcp-product-image-container">
          <div className="pcp-side-image">
            <button className="pcp-nav-arrow up" onClick={scrollUp}>
              <img src={up} alt="Scroll up" />
            </button>
            <div className="pcp-show-image" ref={thumbnailRef}>
              {Array.isArray(productDetails.product_image)
                ? productDetails.product_image.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    className={`select-image ${index === activeImageIndex ? 'active' : ''}`}
                    onClick={() => setActiveImageIndex(index)}
                    alt={`Thumbnail ${index + 1}`}
                  />
                ))
                : (
                  <img
                    src={productDetails.product_image} // Assuming product_image is a single URL
                    className="select-image active"
                    alt="Thumbnail"
                  />
                )
              }
            </div>
            <button className="pcp-nav-arrow down" onClick={scrollDown}>
              <img src={down} alt="Scroll down" />
            </button>
          </div>

          <div className="pcp-main-product-container">
            <img
              src={
                Array.isArray(productDetails.product_image)
                  ? productDetails.product_image[activeImageIndex]
                  : productDetails.product_image
              }
              className="pcp-main-product"
              alt="Main product"
            />
          </div>
        </div>

        <div className="pcp-product-detail-box">
          <div className="pcp-product-header">
            <div className="pcp-product-title-ch-inline">
              <h1 className="pcp-product-title">{productDetails.name}</h1>
              {/* <div className="pcp-stocks-status-inline">In Stock</div> */}
            </div>
            <span className="ff-poppins fs-12" style={{ color: "#00b207" }}>
              {productDetails.sellerName || "Unknown Seller"}
            </span>
            <div className="pcp-rating-sku">
              <div className="pcp-rating">
                <ReactStars
                  {...starRatingConfig}
                  key={`stars-${productDetails.average_rating}`}
                />
              </div>
              <span className="pcp-review-count">{productDetails.average_rating || 0} rating</span> <span className="pcp-dot">•</span>
              {/* <div className="pcp-sku">
                <span>SKU:</span><span className="pcp-num"> {productDetails.sku || "N/A"}</span>
              </div> */}
            </div>
          </div>

          <div className="pcp-price-section">
            <div className="pcp-price-row">
              {productDetails.original_price && (
                <span className="pcp-original-price">Ksh {productDetails.original_price.toFixed(2)}</span>
              )}
              {productDetails.discount_price && (
                <span className="pcp-current-price">Ksh {productDetails.discount_price.toFixed(2)}</span>
              )}
              {(productDetails.original_price && productDetails.discount_price) && (
                <div className="pcp-discount-badge">
                  {Math.round(((productDetails.original_price - productDetails.discount_price) / productDetails.original_price) * 100)}% Off
                </div>
              )}
            </div>
          </div>

          <div className="dividers"></div>

          <div className="pcp-brand-section">
            <div className="pcp-brand-header">
              {/* <span className="pcp-brand-label">Brand:</span>
              <div className="pcp-brand-logo-containers-qc">
                <img src={brandLogo} alt="brand" className="pcp-brand-logo-qc" />
              </div> */}
              <div className="pcp-share-section-product">
                <span>Share item:</span>
                <div className="pcp-social-icon-product">
                  <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                  >
                    <FaFacebookF />
                  </a>
                  <a
                    href="https://x.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Twitter"
                  >
                    <FaTwitter />
                  </a>
                  <a
                    href="https://in.pinterest.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Pinterest"
                  >
                    <FaPinterestP />
                  </a>
                  <a
                    href="https://www.instagram.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <FaInstagram />
                  </a>
                </div>
              </div>
            </div>
            <p className="pcp-brand-description">
              {/* {productDetails.short_description || 'No description available.'} */}
              <div
            className="pcp-brand-description"
            dangerouslySetInnerHTML={{ __html: cleanHTML }}
          />
            </p>
          </div>

          <div className="dividers"></div>

          <div className="pcp-cta-section">
            <div className="pcp-quantity-selectors">
              <button className="pcp-quantity-btn minus" onClick={decreaseQuantity}>-</button>
              <span className="pcp-quantity">{quantity}</span>
              <button className="pcp-quantity-btn plus" onClick={increaseQuantity}>+</button>
            </div>

            <button className="pcp-add-to-cart" onClick={() => handleAddToCart({ ...productDetails, quantity })}>
              Add to Cart <img src={cartIcon} alt="cart" />
            </button>

            <button 
              className={`pcp-wish-btn ${isInWishlist ? 'wishlist-active' : ''}`} 
              aria-label="Add to wishlist" 
              onClick={handleWishlistClick}
            >
              {isInWishlist ? (
                <FaHeart style={{ color: '#00b207', fontSize: '16px' }} />
              ) : (
                <FaRegHeart style={{ color: '#1a1a1a', fontSize: '16px' }} />
              )}
            </button>
          </div>

          <div className="pcp-category-tags">
            <div className="pcp-category">
              <span>Category:</span> <span>{productDetails.category_id.category_name || 'General'}</span>
            </div>
            <div className="pcp-tags">  
              <span>Tags:</span>
              {(productDetails.tag || ['Healthy']).map((tags, i) => (
                <span key={i}>{tags}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ProductCardpop;